<template>
  <section>
    <v-btn outlined color="orange" :to="`/elections/${election}`">
      <v-icon left>mdi-arrow-left-circle</v-icon>
      Return to election
    </v-btn>

    <h2 class="mt-5">
      Voters for {{ electionAssociation.description }} Election
    </h2>

    <v-data-table
      dense
      :headers="headers"
      :items="voters"
      class="mt-5 elevation-1"
      hide-default-footer
      loading-text="Loading... Please wait"
      :footer-props="tableFooterProps"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        <small>{{ formatDateOnly(item.created_at) }}</small>
      </template>
      <template v-slot:[`item.voted`]="{ item }">
        <v-icon small :color="item.voted ? 'green' : ''">
          {{ item.voted > 0 ? "mdi-check" : "mdi-close" }}
        </v-icon>
      </template>
      <template v-slot:[`item.contesting`]="{ item }">
        <v-icon small :color="item.contesting ? 'green' : ''">
          {{ item.contesting > 0 ? "mdi-check" : "mdi-close" }}
        </v-icon>
      </template>
      <template v-slot:[`item.smsNotification`]="{ item }">
        <v-icon small :color="item.smsNotification ? 'green' : ''">
          {{ item.sms_notification > 0 ? "mdi-check" : "mdi-close" }}
        </v-icon>
      </template>
      <template v-slot:[`item.emailNotification`]="{ item }">
        <v-icon small :color="item.emailNotification ? 'green' : ''">
          {{ item.email_notification > 0 ? "mdi-check" : "mdi-close" }}
        </v-icon>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <v-btn icon color="red" @click="removeVoter(item.id)">
          <v-icon small>mdi-delete-outline</v-icon>
        </v-btn>
        <v-btn icon color="blue">
          <v-icon small>mdi-archive-remove-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <div class="text-right pt-5">
      <v-pagination
        color="brown darken-2"
        total-visible="7"
        @input="loadElectionVoters"
        v-model="meta.current_page"
        :length="meta.last_page"
      ></v-pagination>
    </div>
  </section>
</template>

<script>
import { timeago, formatDateOnly } from "../../tools/format";
export default {
  props: ["election"],

  data: () => ({
    voters: [],
    headers: [
      {
        text: "Accredited",
        align: "start",
        sortable: false,
        value: "created_at",
      },
      { text: "Reg. Number", value: "reg_number" },
      { text: "Student", value: "name" },
      { text: "Course", value: "course_name" },
      { text: "PIN Email", value: "pin_retrieve_email" },
      { text: "Cont.", value: "contesting" },
      { text: "Voted", value: "voted" },
      { text: "SMS", value: "smsNotification" },
      { text: "Email", value: "emailNotification" },
      { text: "Actions", value: "id", sortable: false },
    ],
    tableFooterProps: {
      itemsPerPageOptions: [-1],
    },
    meta: {
      total: 0,
      last_page: 0,
      current_page: 0,
    },

    query: null,
    electionAssociation: {},
    electionSession: {},
  }),

  methods: {
    timeago,
    formatDateOnly,
    loadElectionVoters(page = 1) {
      this.$axios
        .get(`/beta/voters/${this.election}?page=${page}`)
        .then(async ({ data: { data: voters, meta } }) => {
          this.voters = voters;

          this.meta = meta;
        });
    },
    removeVoter(id) {
      console.log(id);
    },
    loadElectionDetails() {
      this.$axios
        .get(`/election/${this.election}`)
        .then(({ data: election }) => {
          const { association, session } = election;
          this.electionAssociation = association;
          this.electionSession = session;
          this.session = session.sSesId;
        })
        .catch((error) => {
          if (error.response.status == 404)
            this.$router.push({ name: "elections" });

          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Election not found",
          });
        });
    },
  },

  mounted() {
    this.loadElectionVoters();
    this.loadElectionDetails();
  },
};
</script>
